import { Icons } from '@/components/icons';
import {
  defaultNumberFilter,
  defaultRelationFilter,
  defaultSelectFilter,
  defaultStringFilter,
  type Filter,
} from '@/components/table-filters/constants';
import {
  IndustrialPremisesConfig,
  TenantConfig,
} from '@pigello/pigello-matrix';
import baseRevenueIncreaseFilters from '../contracts/components/base-revenue-increase-filters';
import baseFilters, {
  baseAddressFilters,
  baseBuildingFilter,
  baseGlobalRealEstatesFilter,
  baseSpaceFutureContractingFilters,
  baseSpaceStatusFilters,
  baseTagFilter,
} from '../filters';

const industrialPremisesFilters: Filter[] = [
  ...baseSpaceStatusFilters,
  ...baseSpaceFutureContractingFilters,
  ...baseBuildingFilter,
  ...baseGlobalRealEstatesFilter,
  {
    ...defaultSelectFilter,
    title: IndustrialPremisesConfig.fields.category.verboseName,
    externalFieldName:
      IndustrialPremisesConfig.fields.category.externalFieldName,
    choices: IndustrialPremisesConfig.fields.category.choices,
  },
  {
    ...defaultStringFilter,
    title: IndustrialPremisesConfig.fields.popularName.verboseName,
    externalFieldName:
      IndustrialPremisesConfig.fields.popularName.externalFieldName,
  },
  {
    ...defaultStringFilter,
    title: IndustrialPremisesConfig.fields.landlordCustomId.verboseName,
    externalFieldName:
      IndustrialPremisesConfig.fields.landlordCustomId.externalFieldName,
    icon: Icons.id,
  },
  {
    ...defaultStringFilter,
    title: IndustrialPremisesConfig.fields.customId.verboseName,
    externalFieldName:
      IndustrialPremisesConfig.fields.customId.externalFieldName,
    icon: Icons.id,
  },
  {
    ...defaultNumberFilter,
    title: IndustrialPremisesConfig.fields.usableArea.verboseName,
    externalFieldName:
      IndustrialPremisesConfig.fields.usableArea.externalFieldName,
  },
  {
    ...defaultNumberFilter,
    title: IndustrialPremisesConfig.fields.biArea.verboseName,
    externalFieldName: IndustrialPremisesConfig.fields.biArea.externalFieldName,
  },
  {
    ...defaultNumberFilter,
    title: IndustrialPremisesConfig.fields.temperedArea.verboseName,
    externalFieldName:
      IndustrialPremisesConfig.fields.temperedArea.externalFieldName,
  },

  {
    ...defaultRelationFilter,
    title: IndustrialPremisesConfig.fields.tenant.verboseName,
    externalFieldName: IndustrialPremisesConfig.fields.tenant.externalFieldName,
    relationModelName: TenantConfig.modelName,
    icon: Icons.tenant,
  },
  {
    ...defaultRelationFilter,
    title: IndustrialPremisesConfig.fields.biTenants.verboseName,
    externalFieldName:
      IndustrialPremisesConfig.fields.biTenants.externalFieldName,
    relationModelName: TenantConfig.modelName,
    icon: Icons.tenant,
  },
  ...baseRevenueIncreaseFilters,
  ...baseAddressFilters,
  ...baseTagFilter,
  ...baseFilters,
];

export default industrialPremisesFilters;
